<template>
    <ValidationObserver ref="form" >
        <form @submit.prevent="submitForm">
        <div class="field">
            <div class="control">
                <FylkeVassdrag :model="model.fylkeVassdrag"></FylkeVassdrag>
            </div>
               
        </div>
        <div class="field">
            <div class="control">
                <ValidationProvider rules="required" v-slot="{ errors }">
                    <field-select label-text="Type fiske *" v-model="model.fishingTypeId"
                        v-bind:options="fishingTypes" :error="errors[0]" />
                </ValidationProvider>
            </div>
        </div>

        <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
                <field-select label-text="Prøvetype *" v-model="model.sampleTypeId"
                    v-bind:options="sampleTypes" :error="errors[0]" />
            </ValidationProvider>
        </div>

        
   
        <button class="button is-info mr-1 mt-4" type="submit"><span class="icon is-small">
              <i class="fa fa-save"></i>
            </span>
            <span>Opprett</span> 
          </button>

          
    </form>
       
    </ValidationObserver>

</template>

<script>
import FishingTypeEnum from "@/enums/FishingTypeEnum.js"; 
import SampleTypeEnum from "@/enums/SampleTypeEnum.js";
import FylkeVassdrag from '@/components/grouped/FylkeVassdrag.vue';
export default {
    name: "RegistrerBetaling",
    data: function () {
        return {
            fishingTypes: FishingTypeEnum,
            sampleTypes: SampleTypeEnum,
        }
    },
    props: {
        model: {
            type: Object,
            required: true
        }
    },
    components: { FylkeVassdrag},
    mounted() { },
    methods: {
        submitForm(e) {
            e.preventDefault();
            let self = this;
            self.$refs.form.validate().then(success => {
                if (!success) {
                    self.
                        return;
                } 
                else {
                    this.$emit('formSubmitted', this.model );
                }
         })
        }
    }
}


</script>
